module.exports = __webpack_public_path__ + "img/book2-3.236499c6.jpg";